module.exports = __webpack_public_path__ + "img/tree-06-d-leaves.76482aa6.png";